import React from "react";
import Select from "components/forms/Select";
import "./barra-seleccionar-region.block.scss";
import Ubigeo from "../../commons/ubigeo.module";
import { LISTA_REGIONES } from "../../data/ubigeo.data";
let NEW_LISTA_REGIONES = LISTA_REGIONES.filter(item => item.value !== "00");
class BarraSelecionarRegion extends React.Component {
  render() {
    let regionSelecionada = Ubigeo.getObjectRegion(this.props.region);
    return (
      <div className="sinia-block-top-space barra-seleccionar-region">
        <span className="barra-seleccionar-region__label">Región</span>
        <div className="react-select-container">
          <Select
            store={NEW_LISTA_REGIONES}
            item_default={regionSelecionada}
            onChange={this._onRegionChange}
            scope={this}
            placeholder="Seleccione una región"
          />
        </div>
      </div>
    );
  }
  _onRegionChange(itemsSeleccionados) {
    let props = this.props;
    let scope = this.props.scope || this;
    if (props.onRegionChange) {
      props.onRegionChange.call(scope, itemsSeleccionados[0].value);
    }
  }
}
export default BarraSelecionarRegion;
